import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import LoginBig from "./LoginBig";
import LoginSmall from "./LoginSmall";

// Custom hook to detect device type
function useDevice() {
	const [device, setDevice] = useState(getDeviceType());

	function getDeviceType() {
		const width = window.innerWidth;
		if (width < 768) return "mobile";
		if (width < 1024) return "tablet";
		return "desktop";
	}

	useEffect(() => {
		function handleResize() {
			setDevice(getDeviceType());
		}

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return device;
}

// Main component
export default function Login() {
	const device = useDevice();
	const location = useLocation();
	const history = useHistory();

	return (
		<div>
			{device === "mobile" && <LoginSmall />}
			{device === "tablet" && <LoginBig location={location} history={history} device = {device} />}
			{device === "desktop" && <LoginBig location={location} history={history} device = {device}  />}
		</div>
	);
}
